/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import template from "templates/layout/pagination.hbs";

import { View } from "backbone.marionette";

export default class PaginationView extends View.extend({
  template
}) {
  initialize(options) {
    return (this.options = options);
  }

  serializeData() {
    const bodyEl = document.getElementById("region-main");

    const totalPages = bodyEl?.dataset.totalPages
      ? parseInt(bodyEl.dataset.totalPages, 10)
      : 0;

    const currentPage = bodyEl?.dataset.currentPage
      ? parseInt(bodyEl.dataset.currentPage, 10)
      : 1;

    // eslint-disable-next-line no-restricted-globals
    if (isNaN(totalPages) || isNaN(currentPage))
      return {
        hasPagination: false
      };

    const pages = totalPages
      ? [...Array(totalPages).keys()].map(i => `${i + 1}`)
      : [];

    return {
      pages,
      hasPagination: totalPages > 1,
      totalPages: `${totalPages}`,
      currentPage: `${currentPage}`,
      previousPage: currentPage === 1 ? "1" : `${currentPage - 1}`,
      nextPage:
        currentPage === totalPages ? `${currentPage}` : `${currentPage + 1}`
    };
  }
}
